<template>
    <el-dialog title="项目人员列表" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>职位：</label>
                    <el-input v-model="search_Obj.f_position" clearable @keyup.enter.native="doSearch" style="width:140px"></el-input>
                </div>
                <div class="searchGroup">
                    <label>姓名：</label>
                    <el-input v-model="search_Obj.f_name" clearable @keyup.enter.native="doSearch" style="width:140px"></el-input>
                </div>
                <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
                <el-button type="primary"  @click="toAddPersion">添加</el-button>
                <el-button type="danger"  @click="delAll">删除</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                    <el-table-column prop="position" label="职位"></el-table-column>
                    <el-table-column prop="name" label="姓名" ></el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column prop="order_index" label="顺序"></el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button  size="mini" plain type="primary" @click="edit(scope.$index, scope.row)">编辑</el-button>
                            <el-button  size="mini" plain type="danger" @click="del(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
        <AddPerson
            width="600px"
            :title="edit_title"
            :id="model_id"
            :data_id="data_id"
            :isshow="addshow"
            @on-close="closeAddDialog"
            @on-save-ok="saveOk">
        </AddPerson>
    </el-dialog>
</template>

<script>
import AddPerson from "./personadd.vue"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'

export default {
    name: 'monthReportPersonList',
    mixins: [listutil],
    components: {AddPerson},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        data_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_month_report_id = this.data_id
            if (newv) {
                this.getData()
            }
        }
    },
    data() {
        return {
            showflag: false,
            m_name: '项目人员',
            enu_name: [],
            pagesize: 10,
            list_url: "/api/admin/monthreport/personList",
            search_Obj: {
                f_month_report_id: '',
                f_position: '',
                f_name: '',
            },
            del_Obj:{
                url:'/api/admin/monthreport/deletePerson',
                data:{
                    ids:''
                }
            },
            addshow: false,
        };
    },
    methods: {
        closeDialog(){
            this.$emit("on-close")
        },
        toAddPersion(){
            this.model_id = -1
            this.edit_title = "添加" + this.m_name
            this.addshow = true
        },
        edit(index, row) {
            this.edit_title = "编辑" + this.m_name
            this.model_id = row.id
            this.addshow = true
        },
        closeAddDialog(){
            this.addshow = false
        },
        saveOk(){
            this.addshow = false
            this.getListData()
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            if(this.data_id<1){
                return
            }
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                }
            })
        },
    }
};
</script>